import React, { useState, useEffect, useContext } from 'react';
import { TextField, Checkbox } from '@mui/material';
import { Col, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import './certificates.css'
import Multiselect from 'multiselect-react-dropdown';
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import moment from 'moment';
import ApiService from "../../functions/apiService";
import { toast } from 'react-toastify';
import CalendarLoader from '../../components/Calendar/CalendarLoader';
import AuthContext from "../../context/AuthContext";

const AddCerificate = (props) => {
  const { addModal, setAddModal, editId, setViewId, loadCertificates } = props;
  const { pages } = useContext(AuthContext);
  const [positions, setPositions] = useState([])
  const [employees, setEmployees] = useState([])
  const [name, setName] = useState('')
  const [selectedEmp, setSelectedEmp] = useState([])
  const [selectedPosition, setSelectedPosition] = useState([])
  const [description, setDescription] = useState('')
  const [date, setDate] = useState(new Date())
  const [history, setHistory] = useState('')
  const [noExpiry, setNoExpiry] = useState(false)
  const [loading, setLoading] = useState(false);
  const [isSchedule, setIsSchedule] = useState(false)
  const [isDuty, setIsDuty] = useState(false)

  const loadPositionsData = () => {
    setLoading(true);
    ApiService.get('/positions-list?search=')
      .then(({ data }) => {
        setPositions(data?.data)
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      })
  }

  const loadEmployees = () => {
    setLoading(true);
    ApiService.get('/employees-list?search=')
      .then(({ data }) => {
        var tempArr = []
        data.data.map((emp) => {
          var obj = emp
          obj.label = `${emp.employee_assignment.EA_Rank} ${emp.fullName}`
          tempArr.push(obj)
        })
        setEmployees(tempArr)
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      })
  }

  const certificateData = () => {
    if (editId) {
      setLoading(true);
      ApiService.get('/certificate-details/' + editId)
        .then(({ data }) => {
          setName(data?.data?.Name)
          setDescription(data?.data?.Description)
          setIsSchedule(data?.data?.Is_Schedule_Enabled)
          setIsDuty(data?.data?.Is_Show_Only_On_Duty)
          var tempArr = []
          data?.data?.certificate_positions.map((pos) => {
            tempArr.push(pos.position)
          })
          setSelectedPosition(tempArr)
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        })
    }
  }

  const addCertificate = () => {
    const body = {
      "Name": name,
      "Description": description,
      "Emp_Codes": selectedEmp.map((a) => { return a.Emp_Code }),
      "Positions": selectedPosition.map((a) => { return a.SO_Value }),
      "Expiration_Date": noExpiry ? null : date,
      "Training_History": history,
      "Is_Schedule_Enabled": isSchedule,
      "Is_Show_Only_On_Duty": isDuty
    }
    setLoading(true);
    ApiService.post('/add-certificate', body)
      .then((data) => {
        setAddModal(false)
        loadCertificates()
        toast.success(data.message)
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.status == 422) {
          Object.keys(error.data.errors).map((err) => (
            toast.error(error.data.errors[err][0])
          ))
        }
        else {
          toast.error(error.data.message)
        }
      })
  }

  const editCertificate = () => {
    const body = {
      "Name": name,
      "Description": description,
      "Positions": selectedPosition.map((a) => { return a.SO_Value }),
      "Is_Schedule_Enabled": isSchedule,
      "Is_Show_Only_On_Duty": isDuty
    }
    setLoading(true);
    ApiService.post('/update-certificate/' + editId, body)
      .then((data) => {
        setAddModal(false)
        loadCertificates()
        setViewId('')
        toast.success(data.message)
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.status == 422) {
          Object.keys(error.data.errors).map((err) => (
            toast.error(error.data.errors[err][0])
          ))
        }
        else {
          toast.error(error.data.message)
        }
      })
  }

  useEffect(() => {
    loadPositionsData()
    loadEmployees()
    certificateData()
  }, [])


  return (
    <>
      <Modal show={addModal} size="lg" onHide={() => {
        setAddModal(false)
        setViewId('')
      }}>
        <Modal.Header closeButton>
          <Modal.Title>{editId ? 'Edit' : 'Add New'} Certificate</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className='w-100' style={{ flexWrap: 'wrap' }}>
            <Col md={6}>
              <label className='my-1'>Certificate Name</label>
              <TextField
                className='mt-1 w-100' color='secondary' variant="outlined" value={name}
                label="Certificate Name" onChange={(e) => setName(e.target.value)}
              />
            </Col>
            <Col md={6}>
              <label className='my-1'>Description</label>
              <TextField
                className='mt-1 w-100' color='secondary' variant="outlined" value={description}
                label="Description" onChange={(e) => setDescription(e.target.value)} multiline
              />
            </Col>
            {!editId &&
              <Col md={6}>
                <label className='my-2'>Members</label>
                {/* <Multiselect
                  displayValue='label'
                  options={employees}
                  showCheckbox
                  showArrow
                  customCloseIcon={<><img src='/images/cross.png' /></>}
                  placeholder='Members'
                  onSelect={(e) => setSelectedEmp(e)}
                  selectedValues={selectedEmp}
                /> */}

                <Multiselect
                  displayValue="label"
                  options={employees}
                  showCheckbox
                  showArrow
                  customCloseIcon={<img src="/images/cross.png" alt="close" />}
                  placeholder="Members"
                  selectedValues={selectedEmp}
                  onSelect={(e) => setSelectedEmp(e)}
                  onRemove={(e) => setSelectedEmp(e)}
                  customInputRenderer={(inputProps) => (
                    <TextField
                      {...inputProps}
                      variant="outlined"
                      fullWidth
                      size="small"
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "48px",
                          fontSize: "14px",
                          display: "flex",
                          alignItems: "center",
                        },
                      }}
                    />
                  )}
                />


              </Col>
            }
            <Col md={6}>
              <label className='my-2'>Positions</label>
              <Multiselect
                displayValue='SO_Desc'
                options={positions}
                showCheckbox
                showArrow
                customCloseIcon={<><img src='/images/cross.png' /></>}
                placeholder='Positions'
                onSelect={(e) => setSelectedPosition(e)}
                onRemove={(e) => setSelectedPosition(e)}
                selectedValues={selectedPosition}
              />
            </Col>
            {!editId &&
              <>
                <Col md={6} className='d-grid'>
                  <label className='my-2'>Expiration Date</label>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <ButtonDatePicker
                      className='w-100'
                      label={noExpiry ? 'No expiry' : moment(date).format('MM-DD-YYYY')}
                      value={new Date(date)}
                      onChange={(e) => {
                        setDate(moment(e).format('YYYY-MM-DD'))
                        setNoExpiry(false)
                      }}
                      minDate={new Date()}
                    />
                  </LocalizationProvider>
                  <Row>
                    <Col md='auto' className='p-0'>
                      <Checkbox label={'hr'}
                        checked={noExpiry}
                        onClick={() => setNoExpiry(!noExpiry)}
                      />
                    </Col>
                    <Col md={8} className='p-0'>
                      <label className='mt-2'>No Expiry Date</label>
                    </Col>
                  </Row>
                </Col>
                <Col md={6}>
                  <label className='my-2'>Training History</label>
                  <TextField
                    className='w-100' color='secondary' variant="outlined" multiline
                    label="Training history" onChange={(e) => setHistory(e.target.value)}
                  />
                </Col>
              </>
            }

            <Col md={12}>
              <Row style={{ marginTop: editId ? 30 : 0 }}>
                <Col md='auto' className='p-0'>
                  <Checkbox label={'hr'}
                    checked={isSchedule}
                    onClick={() => setIsSchedule(!isSchedule)}
                  />
                </Col>
                <Col md={8} className='p-0'>
                  <label className='mt-2'>Is Schedule Certificate</label>
                </Col>
              </Row>
            </Col>

            <Col md={12}>
              <Row>
                <Col md='auto' className='p-0'>
                  <Checkbox label={'hr'}
                    checked={isDuty}
                    onClick={() => setIsDuty(!isDuty)}
                  />
                </Col>
                <Col md={8} className='p-0'>
                  <label className='mt-2'>On Duty Employess</label>
                </Col>
              </Row>
            </Col>

          </Row>

          <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4'
            onClick={() => { editId ? editCertificate() : addCertificate() }}>
            {editId ? 'Update' : 'Create'}
          </ButtonTheme>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default AddCerificate;